import { useEffect } from 'react';

interface SchemaMarkupProps {
  schema: Record<string, unknown>;
}

export function SchemaMarkup({ schema }: SchemaMarkupProps) {
  useEffect(() => {
    const id = 'schema-ld';
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, [schema]);
  return null;
}